import React, { useState, useEffect } from "react";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import { Row, Col } from "reactstrap";
import Switch from "react-switch";
import { useDispatch, useSelector } from "react-redux";
import { reactLocalStorage } from "reactjs-localstorage";
import ReactExport from "react-export-excel";
import {
  EMPTY_DATA,
  SpeciaList,
  defaultPageSize,
} from "../../../../../../../../config/constants";
import { setSelectedRowForPagination } from "../../../../../../../simulation/actions/Simulation";
import { SPECILIZATION_LIST_EXCEL } from "../../../../../../../../config/masterData";
import { resetStatePagination } from "../../../../../../../common/Pagination/paginationAction";
import NoContentFound from "../../../../../../../common/NoContentFound";
import LoaderCustom from "../../../../../../../common/LoaderCustom";
import {
  handleDepartmentHeader,
  loggedInUserId,
  searchNocontentFilter,
  setLoremIpsum,
  showTitleForActiveToggle,
} from "../../../../../../../../helper";
import { fetchAllVendoreNeedFormApprovalList } from "../../Action";
import DayTime from "../../../../../../../common/DayTimeWrapper";
import { Drawer } from "@material-ui/core";
import ViewApprovalSummarySnf from "../ViewApprovalSummarySnf";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const gridOptions = {};

const VendorNeedApprovalListSnf = (props) => {
  const { vendorNeedFormApproval } = useSelector(
    (state) => state?.VendorNeedFormApprovalList
  );
  const urlParams = new URLSearchParams(window.location.search);
  const selfAssesmentId = urlParams.get("VendorRequirementRegistrationId");
  const dispatch = useDispatch();
  const [loader, setloader] = useState(false);
  const [approvalNumber, setApprovalNumber] = useState(null)
  const [open, setOpen] = useState(false);
  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };
  const currentListQty = (vendorNeedFormApproval?.Page - 1) * 10;
  let serialNumber = currentListQty + 1; // Start numbering from 1
  // const usersWithSerialNumbers = vendorNeedFormApproval?.Data;
  const usersWithSerialNumbers = (vendorNeedFormApproval?.Data || []).map(
    (user, index) => {
      const updatedSerialNumber = serialNumber + index;
      return {
        ...user,
        serialNumber: updatedSerialNumber,
      };
    }
  );

  const [state, setState] = useState({
    isEditFlag: false,
    isOpenVendor: false,
    shown: false,
    ID: "",
    tableData: [],
    city: [],
    country: [],
    state: [],
    showPopup: false,
    deletedId: "",
    cellData: {},
    cellValue: "",
    showPopupToggle: false,
    isViewMode: false,
    isLoader: false,
    selectedRowData: false,
    noData: false,
    dataCount: 0,
    type: "",
    render: false,
    showExtraData: false,
  });

  const getUsers = async (currentPage, pageSize, sortOrder, fieldName) => {
    try {
      // Set loader to true to indicate data fetching
      setloader(true);
      // Dispatch the action to fetch users
      await dispatch(
        fetchAllVendoreNeedFormApprovalList({
          vendorRequirementRegistrationId: props?.selfAssesmentId,
        })
      );
      // Reset loader to false after the data is fetched
      setloader(false);
    } catch (error) {
      // Handle errors, e.g., display an error message

      // Reset loader to false in case of an error
      setloader(false);
    }
  };
  /**
   * @method onFloatingFilterChanged
   * @description Filter data when user type in searching input
   */
  const onFloatingFilterChanged = (value) => {
    setTimeout(() => {
      if (usersWithSerialNumbers.length !== 0) {
        setState((prevState) => ({
          ...prevState,
          noData: searchNocontentFilter(value, prevState.noData),
        }));
      }
    }, 500);
  };

  useEffect(() => {
    // Function to fetch data after a 3-second delay
    const fetchDataWithDelay = async () => {
      // Show loader
      setloader(true);

      // Simulate loading for 3 seconds
      await new Promise((resolve) => setTimeout(resolve, 500));

      try {
        // Fetch data after the delay
        await getUsers(1, defaultPageSize, "ASC");
      } catch (error) {

      } finally {
        // Hide loader after fetching data or encountering an error
        setloader(false);
      }
    };
    // Call fetchDataWithDelay function
    fetchDataWithDelay();
  }, []);
  useEffect(() => {
    reactLocalStorage.setObject("selectedRow", {});
    if (!props.stopApiCallOnCancel) {
      return () => {
        dispatch(setSelectedRowForPagination([]));
        dispatch(resetStatePagination());

        reactLocalStorage.setObject("selectedRow", {});
      };
    }
  }, []);
  const onRowSelect = () => {
    const selectedRows = state.gridApi?.getSelectedRows();
    setState((prevState) => ({
      ...prevState,
      selectedRowData: selectedRows,
      dataCount: selectedRows.length,
    }));
  };
  const onBtExport = () => {
    let tempArr = state.gridApi && state.gridApi.getSelectedRows();
    tempArr =
      tempArr && tempArr.length > 0
        ? tempArr
        : usersWithSerialNumbers
          ? usersWithSerialNumbers
          : [];
    return returnExcelColumn(SPECILIZATION_LIST_EXCEL, tempArr);
  };

  const returnExcelColumn = (data = [], TempData) => {
    return (
      <ExcelSheet data={TempData} name={SpeciaList}>
        {data &&
          data.map((ele, index) => (
            <ExcelColumn
              key={index}
              label={
                ele.label === "Company Name"
                  ? `${handleDepartmentHeader()} Name`
                  : ele.label
              }
              value={ele.value}
              style={ele.style}
            />
          ))}
      </ExcelSheet>
    );
  };
  const isFirstColumn = (params) => {
    var displayedColumns = params.columnApi.getAllDisplayedColumns();
    var thisIsFirstColumn = displayedColumns[0] === params.column;
    return thisIsFirstColumn;
  };
  const defaultColDef = {
    resizable: true,
    filter: true,
    sortable: false,
    headerCheckboxSelectionFilteredOnly: true,
    checkboxSelection: isFirstColumn,
  };
  const onGridReady = (params) => {
    window.screen.width >= 1600 && params.api.sizeColumnsToFit();
    setState((prevState) => ({
      ...prevState,
      gridApi: params.api,
      gridColumnApi: params.columnApi,
    }));
    params.api.paginationGoToPage(0);
  };
  const buttonFormatter = (props) => {
    props.api.sizeColumnsToFit();

    // setWorkFlowProcess(props?.data)
    const handleView = () => {
      const requestId = props?.data?.WorkFlowProcess;
      setApprovalNumber(props?.data?.ApplicationNo)
      setOpen({ open: true, id: requestId });

    };
    return (
      <div>
        <button
          title="View"
          className="View hl-accept-icon mr-2"
          type="button"
          onClick={handleView}
        ></button>
      </div>
    );
  };
  const statusButtonFormatter = (props) => {
    const cellValue = props?.valueFormatted
      ? props?.valueFormatted // Fix: Change 'valueFormatted' to 'valueFormatted'
      : props?.value;
    const rowData = props?.valueFormatted
      ? props?.valueFormatted // Fix: Change 'valueFormatted' to 'valueFormatted'
      : props?.data;
    showTitleForActiveToggle(props?.rowIndex, "Active", "Inactive");
    return (
      <>
        <label
          htmlFor="normal-switch"
          className="normal-switch Tour_List_Status"
        >
          <Switch
            onChange={() => handleChange(cellValue, rowData)}
            checked={cellValue}
            background="#ff6600"
            onColor="#4DC771"
            onHandleColor="#ffffff"
            offColor="#FC5774"
            id="normal-switch"
            height={24}
            className={cellValue ? "active-switch" : "inactive-switch"}
          />
        </label>
      </>
    );
  };

  const handleChange = (cell, row) => {
    let data = {
      Id: row.Id,
      ModifiedBy: loggedInUserId(),
      IsActive: !cell, //Status of the user.
    };
    setState((prevState) => ({
      ...prevState,
      showPopupToggle: true,
      cellData: data,
      cellValue: cell,
    }));
  };
  const effectiveDateFormatter = (props) => {
    const cellValue = props?.valueFormatted
      ? props.valueFormatted
      : props?.value;
    return cellValue != null ? DayTime(cellValue).format("DD/MM/YYYY") : "";
  };
  const frameworkComponents = {
    totalValueRenderer: buttonFormatter,
    statusButtonFormatter: statusButtonFormatter,
    // customNoRowsOverlay: NoContentFound,
    effectiveDateFormatter: effectiveDateFormatter,
  };
  return (
    <>
      {loader && <LoaderCustom customClass="simulation-Loader hl-loader-fixed" />}
      <>
        <Row className="ag-grid-react without-filter-grid">
          <Col>
            <div>
              <div
                className={`ag-theme-material ${loader && "max-loader-height"}`}
              >
                <Row className={`filter-row-large mt-4`}>
                  <Col md="12" className="mb-3 d-flex justify-content-end">
                    <div className="d-flex justify-content-end bd-highlight w100">
                      <>
                        <>
                          <ExcelFile
                            filename={SpeciaList}
                            fileExtension={".xls"}
                            element={
                              <button
                                title={`Download ${state.dataCount === 0
                                  ? "All"
                                  : "(" + state.dataCount + ")"
                                  }`}
                                type="button"
                                className={"user-btn mr5 Tour_List_Download"}
                              >
                                <div className="download mr-1"></div>
                                {`${state.dataCount === 0
                                  ? "All"
                                  : "(" + state.dataCount + ")"
                                  }`}
                              </button>
                            }
                          >
                            {onBtExport()}
                          </ExcelFile>
                        </>
                      </>
                    </div>
                  </Col>
                </Row>
                <div
                  className={`ag-grid-wrapper height-width-wrapper ${(usersWithSerialNumbers &&
                    usersWithSerialNumbers?.length <= 0) ||
                    state.noData
                    ? "overlay-contain"
                    : ""
                    }`}
                >
                  <div
                    className={`ag-theme-material ${state.isLoader && "max-loader-height"
                      }`}
                  >
                    {usersWithSerialNumbers?.length <= 0 && (
                      <NoContentFound
                        title={EMPTY_DATA}
                        customClassName="no-content-found"
                      />
                    )}
                    {state.isLoader ? (
                      <LoaderCustom customClass="loader-center hl-loader-fixed" />
                    ) : (
                      <AgGridReact
                        defaultColDef={defaultColDef}
                        floatingFilter={true}
                        domLayout="autoHeight"
                        // columnDefs={c}
                        rowData={
                          state.showExtraData && usersWithSerialNumbers
                            ? [
                              ...setLoremIpsum(usersWithSerialNumbers[0]),
                              ...usersWithSerialNumbers,
                            ]
                            : usersWithSerialNumbers
                        }
                        pagination={true}
                        paginationPageSize={defaultPageSize}
                        onGridReady={onGridReady}
                        gridOptions={gridOptions}
                        noRowsOverlayComponent={"customNoRowsOverlay"}
                        rowSelection={"multiple"}
                        suppressRowClickSelection={true}
                        onSelectionChanged={onRowSelect}
                        onFilterModified={onFloatingFilterChanged}
                        frameworkComponents={frameworkComponents}
                      >
                        <AgGridColumn
                          cellClass="has-checkbox"
                          field="EmployeeCode"
                          comparator={(
                            valueA,
                            valueB,
                            nodeA,
                            nodeB,
                            isInverted
                          ) =>
                            valueA
                              .toLowerCase()
                              .localeCompare(valueB.toLowerCase())
                          }
                          headerName="Employee Code"
                        ></AgGridColumn>
                        <AgGridColumn
                          field="Position"
                          filter={true}
                          comparator={(
                            valueA,
                            valueB,
                            nodeA,
                            nodeB,
                            isInverted
                          ) =>
                            valueA
                              .toLowerCase()
                              .localeCompare(valueB.toLowerCase())
                          }
                          headerName="Position"
                        ></AgGridColumn>
                        <AgGridColumn
                          field="WorkDoneByEmployee"
                          floatingFilter={true}
                          headerName="Work Done By Employee"
                        ></AgGridColumn>
                        <AgGridColumn
                          field="WorkFlowProcess"
                          floatingFilter={true}
                          headerName="Work Flow Process"
                          valueFormatter={(params) =>
                            `Work Flow Process - ${params.value} `
                          }
                        ></AgGridColumn>
                        <AgGridColumn
                          field="Remarks"
                          floatingFilter={true}
                          headerName="Remark"
                        ></AgGridColumn>
                        <AgGridColumn
                          field="Action"
                          floatingFilter={true}
                          headerName="Approve/Reject"
                        ></AgGridColumn>
                        <AgGridColumn
                          field="ActionDate"
                          floatingFilter={true}
                          headerName="Date"
                          cellRenderer={"effectiveDateFormatter"}
                        ></AgGridColumn>
                        <AgGridColumn
                          width="150"
                          headerName="Action"
                          sortable={false}
                          cellRenderer={"totalValueRenderer"}
                          type="rightAligned"
                          floatingFilter={false}
                        ></AgGridColumn>
                      </AgGridReact>
                    )}

                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </>
      <>
        <Drawer open={open} anchor="bottom" onClose={toggleDrawer(false)}>
          <div className={"drawer-wrapper w-100 master-summary-drawer"}>
            <Row className="drawer-heading sticky-top-0">
              <Col>
                <div className={"header-wrapper left"}>
                  <h3> {`Approval Workflow (Application No. ${approvalNumber} )`}</h3>
                </div>
                <div
                  onClick={() => setOpen(false)}
                  className={"close-button right"}
                ></div>
              </Col>
            </Row>
          </div>
          <ViewApprovalSummarySnf
            selfAssesmentId={selfAssesmentId}
            WorkFlowProcess={open?.id}
          />
        </Drawer>
      </>
    </>
  );
};

export default VendorNeedApprovalListSnf;
